import React, { useState } from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Col,
  Label,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import DatePicker from "../../../DatePicker";

const SchedulingModal = ({ onClose, onConfirm, dates }) => {
  const [sequenceShipDate, setSequenceShipDate] = useState(
    dates?.sequenceShipDate || null
  );
  const [processedKittedNeedDate, setProcessedKittedNeedDate] = useState(
    dates?.processedKittedNeedDate || null
  );
  const [backFromOPDate, setBackFromOPDate] = useState(
    dates?.backFromOpDate || null
  );
  const [transmittalNeedDate, setTransmittalNeedDate] = useState(
    dates?.transmittalNeedDate || null
  );
  const [fabCompleteDate, setFabCompleteDate] = useState(
    dates?.fabCompleteDate || null
  );

  const handleSave = () => {
    onConfirm({
      sequenceShipDate: sequenceShipDate,
      processedKittedNeedDate: processedKittedNeedDate,
      backFromOpDate: backFromOPDate,
      transmittalNeedDate: transmittalNeedDate,
      fabCompleteDate: fabCompleteDate,
    });
  };

  const closeBtn = (
    <Button className="close" color="none" onClick={onClose}>
      &times;
    </Button>
  );

  return (
    <Modal isOpen={true} onClosed={onClose} size="sm" centered>
      <ModalHeader close={closeBtn}>Scheduling</ModalHeader>
      <ModalBody>
        <Row>
          <Col md={12} className="mb-3">
            <Label>Sequence Ship</Label>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <DatePicker
                  date={sequenceShipDate}
                  onClick={setSequenceShipDate}
                />
              </div>
              <FontAwesomeIcon
                icon={faTrash}
                className="ml-2"
                style={{ cursor: "pointer" }}
                onClick={() => setSequenceShipDate(null)}
              />
            </div>
          </Col>
          <Col md={12} className="mb-3">
            <Label>Back from OP</Label>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <DatePicker date={backFromOPDate} onClick={setBackFromOPDate} />
              </div>
              <FontAwesomeIcon
                icon={faTrash}
                className="ml-2"
                style={{ cursor: "pointer" }}
                onClick={() => setBackFromOPDate(null)}
              />
            </div>
          </Col>
          <Col md={12} className="mb-3">
            <Label>Fab Complete</Label>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <DatePicker
                  date={fabCompleteDate}
                  onClick={setFabCompleteDate}
                />
              </div>
              <FontAwesomeIcon
                icon={faTrash}
                className="ml-2"
                style={{ cursor: "pointer" }}
                onClick={() => setFabCompleteDate(null)}
              />
            </div>
          </Col>
          <Col md={12} className="mb-3">
            <Label>Processed / Kitted Need</Label>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <DatePicker
                  date={processedKittedNeedDate}
                  onClick={setProcessedKittedNeedDate}
                />
              </div>
              <FontAwesomeIcon
                icon={faTrash}
                className="ml-2"
                style={{ cursor: "pointer" }}
                onClick={() => setProcessedKittedNeedDate(null)}
              />
            </div>
          </Col>
          <Col md={12} className="mb-3">
            <Label>Transmittal Need</Label>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <DatePicker
                  date={transmittalNeedDate}
                  onClick={setTransmittalNeedDate}
                />
              </div>
              <FontAwesomeIcon
                icon={faTrash}
                className="ml-2"
                style={{ cursor: "pointer" }}
                onClick={() => setTransmittalNeedDate(null)}
              />
            </div>
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter className="justify-content-between">
        <Button color={"secondary"} onClick={onClose}>
          Cancel
        </Button>
        <Button color={"success"} onClick={handleSave}>
          Done
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default SchedulingModal;
